import { useMutation, useQueryClient } from '@tanstack/react-query'
import { TiposCredenciaisApi } from '@/services/api-routes'
import type { SalvarTipoCredencialPayload } from '@/types/tipo-credencial'
import { tiposCredenciaisKeys } from '@/http/queryKeys'
import { notifyErrorFor, notifySuccess } from '@/utility/notify'

export const useCriarTipoCredencialMutation = (onSuccess?: (id: string | null) => void) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: SalvarTipoCredencialPayload) => TiposCredenciaisApi.criar(body),
    onSuccess: (tipo) => {
      void queryClient.invalidateQueries({ queryKey: tiposCredenciaisKeys.lists() })
      notifySuccess('Tipo de credencial criado com sucesso!')
      onSuccess?.(tipo?.id ?? null)
    },
    onError: (error) => notifyErrorFor('criar o tipo de credencial', error),
  })
}

export const useAtualizarTipoCredencialMutation = (
  tipoCredencialId: string,
  onSuccess?: () => void,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: SalvarTipoCredencialPayload) =>
      TiposCredenciaisApi.atualizar(tipoCredencialId, body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: tiposCredenciaisKeys.lists() })
      void queryClient.invalidateQueries({ queryKey: tiposCredenciaisKeys.detail(tipoCredencialId) })
      notifySuccess('Tipo de credencial atualizado com sucesso!')
      onSuccess?.()
    },
    onError: (error) => notifyErrorFor('atualizar o tipo de credencial', error),
  })
}
